
const VariationsCard = () => {
    return (
        <div className="card card-flush py-4">

            <div className="card-header">
                <div className="card-title">
                    <h2>Variations</h2>
                </div>
            </div>


            <div className="card-body pt-0">

                <div className="" data-kt-ecommerce-catalog-add-product="auto-options">

                    <label className="form-label">Add Product Variations</label>


                    <div id="kt_ecommerce_add_product_options">

                        <div className="form-group">
                            <div data-repeater-list="kt_ecommerce_add_product_options"
                                 className="d-flex flex-column gap-3">
                                <div data-repeater-item=""
                                     className="form-group d-flex flex-wrap gap-5">

                                    <div className="w-100 w-md-200px">
                                        <select className="form-select"
                                                name="product_option"
                                                data-placeholder="Select a variation"
                                                data-kt-ecommerce-catalog-add-product="product_option">
                                            <option></option>
                                            <option value="color">Color</option>
                                            <option value="size">Size</option>
                                            <option value="material">Material</option>
                                            <option value="style">Style</option>
                                        </select>
                                    </div>


                                    <input type="text"
                                           className="form-control mw-100 w-200px"
                                           name="product_option_value"
                                           placeholder="Variation"/>

                                    <button type="button" data-repeater-delete=""
                                            className="btn btn-sm btn-icon btn-light-danger">
                                        <span className="svg-icon svg-icon-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <rect opacity="0.5" x="7.05025"
                                                      y="15.5356" width="12"
                                                      height="2" rx="1"
                                                      transform="rotate(-45 7.05025 15.5356)"
                                                      fill="black"/>
                                                <rect x="8.46447" y="7.05029"
                                                      width="12" height="2"
                                                      rx="1"
                                                      transform="rotate(45 8.46447 7.05029)"
                                                      fill="black"/>
                                            </svg>
                                        </span>

                                    </button>
                                </div>
                            </div>
                        </div>


                        <div className="form-group mt-5">
                            <button type="button" data-repeater-create=""
                                    className="btn btn-sm btn-light-primary">
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="24" height="24" viewBox="0 0 24 24"
                                         fill="none">
                                        <rect opacity="0.5" x="11" y="18" width="12"
                                              height="2" rx="1"
                                              transform="rotate(-90 11 18)"
                                              fill="black"/>
                                        <rect x="6" y="11" width="12" height="2"
                                              rx="1" fill="black"/>
                                    </svg>
                                </span>
                                Add another variation
                            </button>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default VariationsCard;